var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError120(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.002 75H65.002V85H55.002V75ZM55.002 35H65.002V65H55.002V35ZM60.002 10C32.352 10 10.002 32.5 10.002 60C10.002 73.2608 15.2698 85.9785 24.6466 95.3553C29.2895 99.9983 34.8015 103.681 40.8678 106.194C46.9341 108.707 53.4359 110 60.002 110C73.2628 110 85.9805 104.732 95.3573 95.3553C104.734 85.9785 110.002 73.2608 110.002 60C110.002 53.4339 108.709 46.9321 106.196 40.8658C103.683 34.7995 100 29.2876 95.3573 24.6447C90.7144 20.0017 85.2024 16.3188 79.1361 13.806C73.0698 11.2933 66.568 10 60.002 10ZM60.002 100C49.3933 100 39.2191 95.7857 31.7177 88.2843C24.2162 80.7828 20.002 70.6087 20.002 60C20.002 49.3913 24.2162 39.2172 31.7177 31.7157C39.2191 24.2143 49.3933 20 60.002 20C70.6106 20 80.7848 24.2143 88.2862 31.7157C95.7877 39.2172 100.002 49.3913 100.002 60C100.002 70.6087 95.7877 80.7828 88.2862 88.2843C80.7848 95.7857 70.6106 100 60.002 100Z",
    fill: "#D71C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError120);
export default __webpack_public_path__ + "static/media/error-120.760a8df917c8166f3bbb28a3129ee36e.svg";
export { ForwardRef as ReactComponent };